import { h } from '@atomify/jsx';
import { Label } from '@atoms/label/label';

import { BPDFunctionalSvg } from '../svg/svg';

type MarkerVariant =
    | 'eye'
    | '360'
    | 'entrance'
    | 'exit'
    | 'stair'
    | 'generic'
    | 'number'
    | 'house'
    | string;

interface MarkerGenericProps {
    variant: MarkerVariant;
    icon?: string;
    element?: string;
    url?: string | null;
    onClick?: Function;
    eyeDirection?: string | null;
    tooltip?: string | null;
    classes?: string;
    style?: Object;
    size?: 'small' | 'large';
}

interface MarkerBaseProps extends MarkerGenericProps {
    pin?: boolean;
    children?: ChildNode[];
}

interface MarkerProps extends MarkerGenericProps {
    number?: string | number;
}

const MarkerBase = (data: MarkerBaseProps) => {
    const attributes: { [key: string]: any } = {
        class: `c-marker marker--${data.variant} marker--${data.size || 'large'}`,
    };

    if (data.url) attributes.href = data.url;
    if (data.pin) attributes.class += ' marker--pin';
    if (data.classes) attributes.class += ` ${data.classes}`;
    if (data.eyeDirection)
        attributes.class += ` marker--direction-${data.eyeDirection.toLowerCase()}`;
    if (data.onClick) attributes.onClick = data.onClick;
    if (data.style) attributes.style = data.style;

    const Tag = data.url ? 'a' : data.element || 'button';

    return (
        <Tag {...attributes}>
            {data.pin && (
                <div class="marker-pin__svg">
                    <BPDFunctionalSvg name="icons-pointer-pin" />
                </div>
            )}
            <span class="marker__inner">
                {data.children && data.children}
                {data.icon && <BPDFunctionalSvg name={data.icon} />}
                {data.tooltip && <Label classes="marker__tooltip" text={data.tooltip} />}
            </span>
        </Tag>
    );
};

const Marker = (data: MarkerProps) => {
    switch (data.variant) {
        case 'eye':
            return (
                <MarkerBase {...{ ...data, icon: 'icons-eye' }}>
                    <span class="marker__eye-direction">
                        <BPDFunctionalSvg name="icons-eye-direction" />
                    </span>
                </MarkerBase>
            );
        case '360':
            return <MarkerBase {...{ ...data }}>360&deg;</MarkerBase>;
        case 'entrance':
            return <MarkerBase {...{ ...data, icon: 'icons-enter' }} />;
        case 'exit':
            return <MarkerBase {...{ ...data, icon: 'icons-exit' }} />;
        case 'stair':
            return <MarkerBase {...{ ...data, icon: 'icons-stair' }} />;
        case 'generic':
            return <MarkerBase {...{ ...data, pin: true }} />;
        case 'number':
            return <MarkerBase {...{ ...data, pin: true }}>{data.number || ''}</MarkerBase>;
    }
};

export { Marker, MarkerProps, MarkerVariant };
